import { useMemo } from 'react';
import { hrSidebarSections } from '@/constant/hr-sidebar-menu';
import { useAuthStore } from '@/state/store/auth';
import { filterMenuItems } from './use-filtered-menu';

/**
 * The sidebar sections the signed-in user can see: items they lack permission for are dropped,
 * and a section left with no items is dropped entirely.
 */
export const usePermittedSidebar = () => {
  const user = useAuthStore((state) => state.user);
  const organizationId = useAuthStore((state) => state.selectedOrgId);

  return useMemo(() => {
    const sections = hrSidebarSections
      .map((section) => ({
        ...section,
        items: filterMenuItems(section.items, { user, organizationId }),
      }))
      .filter((section) => section.items.length > 0);

    // First item the user can open, in sidebar order — where a blocked URL sends them.
    const landingPath = sections[0]?.items[0]?.path ?? null;

    return { sections, landingPath };
  }, [user, organizationId]);
};
